module.exports = __webpack_public_path__ + "img/36.82278014.png";